import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parseInboxSearch } from "@/features/support";
import { InboxPage } from "@/features/support/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/specialists/support/")({
  validateSearch: strictSearch(parseInboxSearch),
  component: Inbox,
});

function Inbox() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <InboxPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
      hrefOf={(threadId) =>
        router.buildLocation({ to: "/specialists/support/$threadId", params: { threadId } }).href
      }
      onOpen={(threadId) =>
        void router.navigate({ to: "/specialists/support/$threadId", params: { threadId } })
      }
    />
  );
}
